import api from "../../index";
import { IOperDayData } from "@/api/mainPage/operDay/interface";

export const cachedOperDay: IOperDayData = {
	currentDate: '',
	opened: false
};

export const $getOperDay = async (): Promise<any> => {
	return api
		.get('cbs/current-day')
		.then(r => r || null);
};

export const $getOperDayCached = ((cachedRequest: Promise<IOperDayData | null> | null) =>
	(): Promise<IOperDayData | null> => {
		if (cachedRequest) return cachedRequest;

		cachedRequest = $getOperDay()
			.then(r => {
				cachedRequest = null;

				Object.assign(cachedOperDay, r || {});

				return r || null;
			});

		return cachedRequest;
	}
)(null);
